import { Controller } from "stimulus"
import Highcharts from "highcharts"

export default class extends Controller
  connect: ->
    data = JSON.parse(@element.dataset.chart)
    labels = 
      try
        JSON.parse(@element.dataset.i18nLabels)

    labels ||= {}

    chart = Highcharts.chart @element,
      chart:
        type: 'area'
        height: 200
        spacingLeft: 20
        spacingTop: 10
        events:
          render: ->
            return unless window.parent?
            window.parent.postMessage {
              sentinel: 'amp'
              type: 'embed-size'
              height: @chartHeight
            }, '*'
      title:
        text: ""
      xAxis:
        type: 'datetime'
        marker: enabled: false
        labels: formatter: ->
          Highcharts.dateFormat('%I:%M%P', @value)
      legend: enabled: false
      yAxis:
        ceiling: Math.max(...data.map((item) => item.y))
        title: enabled: false
        minorTicks: true
      plotOptions:
        line: marker: false
        area:
          fillColor: "#F7F9FC"
        series:
          turboThreshold: 0
          marker: false
          animation: false
          lineWidth: 1
          lineColor: "#9BADBB"
          states: hover: lineWidth: 1
      series: [
        {
          name: "Problems"
          data: data
        }
      ]
      tooltip: formatter: ->
        point = @
        timestamp = "<span style=\"font-size: 10px\">#{(new Date(point.point.dt)).toString()}</span>"
        color_point = "<div style='width: 8px; height: 8px; background: #{point.color}; border-radius: 8px; display: inline-block; margin-right: 4px;'></div>"
        
        count = @.y
        label = 
          if count == 0
            labels['zero']
          else if count == 1
            labels['one']
          else
            labels['other']
          
        "#{timestamp}<br/>#{color_point}<b>#{label.replace("%{count}", count)}</b>"
